/**
 * Learner-seat / onboarding redesign cutover flag.
 * Source of truth: server config `beta_config.learner_seat_cutover` (default OFF),
 * read via the `learner_seat_cutover_enabled()` RPC (see useLearnerSeatCutover).
 * The build-time env (VITE_LEARNER_SEAT_CUTOVER="true") is only a non-production
 * testing fallback. Never reads localStorage, so end users cannot self-enable it.
 */
export function isLearnerSeatCutoverEnabled(): boolean {
  return import.meta.env.VITE_LEARNER_SEAT_CUTOVER === "true";
}

/** Production: the server flag is authoritative. The env override applies only on the local dev server. */
export function resolveCutover({
  env,
  server,
  dev = import.meta.env.DEV === true,
}: { env: boolean; server: boolean | null; dev?: boolean }): boolean {
  return (dev && env) || server === true;
}
